import React from 'react';
import { compose } from 'ramda';
import { SlideContext } from './slideContext';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './SlideButton.js';
import { Button } from '@synergycms_core/components/generic';


const SlideButton = class SlideButton extends React.Component {
  static contextType = SlideContext;
  static displayName = "SlideButton";

  constructor(props) {
    super(props);
  }

  render() {
    const { theme, config, children } = this.props;
    const { direction, className } = config;
    const { next, prev, slides } = this.context;
    const { classes } = theme.styles;
    
    let disabled = false;
    if(direction === 'next' && this.context.snapToLastElement && this.context.position + 1 > slides.length - this.context.visibleItems) disabled = true;
    else if(direction === 'next' && this.context.position + 1 > slides.length - 1) disabled = true;
    else if(direction === 'prev' && this.context.position - 1 < 0) disabled = true;
    
    return (
      <div className={[className,classes.button,disabled ? 'disabled' : ''].join(' ')} onClick={direction === 'next' ? next : prev}>
        <Button {...this.props}>
          {children}
        </Button>
      </div>
    );
  }
}


export default compose(
  PropertyManager([
    'children',
    'direction',
    'className'
  ]),
  withThemeJSS({ styleFile, displayName: 'SlideButton' })
)(SlideButton);